<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.0911 1.18449C11.1161 1.20678 11.1398 1.23047 11.1621 1.25543L20.2745 11.4613C20.601 11.827 20.5692 12.3881 20.2036 12.7146C20.0409 12.8598 19.8305 12.9401 19.6124 12.9401L15.3812 12.9396L15.3817 19.1531C15.3817 19.6433 14.9843 20.0407 14.4941 20.0407H6.50587C6.01567 20.0407 5.61829 19.6433 5.61829 19.1531L5.6178 12.9396L1.38758 12.9401C0.897384 12.9401 0.5 12.5427 0.5 12.0525C0.5 11.8344 0.580271 11.624 0.725501 11.4613L9.83791 1.25543C10.1644 0.889774 10.7255 0.858015 11.0911 1.18449Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgArrowUp',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>